import moment from "moment"
import React from "react"
import DayPickerInput from "react-day-picker/DayPickerInput"
import { Button } from "semantic-ui-react"
import { get } from "store"


const formatDate = date => {
  return moment( date ).format( "DD. MMMM YYYY" )
}


const DeliveryDatePicker = ( { onChange, date } ) => {
  const MIN_DELAY = 3
  // Calculate the earliest available date (MIN_DELAY business days from now, skipping weekends)
  const getEarliestAvailableDate = () => {
    let d = moment();
    let added = 0;
    while (added < MIN_DELAY) {
      d.add(1, "day");
      console.log("adding day",d.format("DD.MM.YYYY"), d.day(), added,)
      if (d.day() !== 0 && d.day() !== 6) {
        added++;
      }
    }
    // If the resulting day is a weekend, move to next Monday
    while (d.day() === 0 || d.day() === 6) {
      d.add(2, "day");
    }
    return d;
  };

  React.useEffect(() => {
    if (!date) {
      const earliest = getEarliestAvailableDate().format("DD. MMMM YYYY");
      onChange(earliest);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  console.log("DeliveryDatePicker date", getEarliestAvailableDate().toDate(), date, moment().add(MIN_DELAY, "day").toDate());
  return (
    <div className={"absolute bottom-0"}>
      <div>
        {date &&
          <div>{moment(date, "DD.MM.YYYY").locale("de").format("dddd, DD. MMMM YYYY")}</div>}
      </div>
      <div className="flex flex-row justify-between">
      <DayPickerInput
        style={{ zIndex: "999", maxWidth: "500px", minWidth: "200px" }}
        value={date}
        placeholder={translate("Ihr Terminwunsch")}
        formatDate={date => moment(date).locale("de").format("DD. MMMM YYYY")}
        dayPickerProps={{
          locale: "de",
          months: moment.localeData("de").months(),
          weekdaysLong: moment.localeData("de").weekdays(),
          weekdaysShort: moment.localeData("de").weekdaysShort(),
          initialMonth: moment().add(MIN_DELAY, "day").toDate(),
          disabledDays: [
            {
              before: getEarliestAvailableDate().toDate()
            },
            { daysOfWeek: [0, 6] }
          ],
          firstDayOfWeek: 1
        }}
        onDayChange={onChange}
        inputProps={{
          readOnly: true
        }}
      />
      {date && (
        <div className="dib pl3">
          <Button basic icon="close" onClick={() => onChange("")} />
        </div>
      )}
      </div>
    </div>
  )
}

export default DeliveryDatePicker


// WEBPACK FOOTER //
// ./src/theme/lindtbShop/components/Date/DeliveryDatePicker.js